module.exports = __webpack_public_path__ + "static/media/meo_logo.2ddf7c94.svg";